import SafeSendersOptionState from '../store/schema/SafeSendersOptionState';
import store from '../store/store';
import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import { action, select } from 'satcheljs/lib/legacy';
import {
    getMailboxJunkEmailConfiguration,
    saveMailboxJunkEmailConfiguration,
} from 'owa-junkmail-configuration';

export interface SaveSafeSendersOptionState {
    optionState: SafeSendersOptionState;
    mailboxJunkEmailConfiguration: MailboxJunkEmailConfigurationOptions;
}

export default select<SaveSafeSendersOptionState>({
    mailboxJunkEmailConfiguration: () => getMailboxJunkEmailConfiguration(),
    optionState: () => store,
})(
    action('saveSafeSendersOption')(async function saveSafeSendersOption(
        state?: SaveSafeSendersOptionState
    ): Promise<void> {
        const { mailboxJunkEmailConfiguration, optionState } = state!;
        mailboxJunkEmailConfiguration.TrustedSendersAndDomains = optionState.safeSenders;
        await saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration);
    })
);
